<template>
  <div style="background: #fff; font-size: 16px; line-height: 30px; padding-bottom: 30px;">
    <table align="center" style="color:#000000; font-size:16px;font-weight:400;width: 700px;">
      <tbody>
      <tr>
        <td align="left">&nbsp;
          <p align="center" style=" text-align:center"><span style="font-size:20px"><strong style="font-size: 20px;">十堰市卫生界学会办公室简介</strong></span></p>
          <p align="center" style=" text-align:center"><span style="font-size:16px">&nbsp;</span></p>
          <p style="text-indent: 2em;font-size:16px;"><span style="font-size:16px;">十堰市卫生界学会办公室直属市卫生健康委员会领导，是十堰市卫生界学会（协会）的综合办事机构。办公室遵循“组织、协调、指导、服务”的原则，以习近平新时代中国特色社会主义思想为指导,坚持党的领导,贯彻执行国家卫生健康、科学技术方针政策，围绕国家、省、市卫生健康工作有关任务和科学技术开展工作，成为发展我市医学科学技术事业的重要社会力量。</span></p>
          <p align="left" style=" text-align:left"><span style="font-size:16px"><strong style="font-size: 20px;">主要职责</strong></span></p>
          <p align="left" style=" text-align:left;text-indent: 2em;font-size:16px;"><span style="font-size:16px;">拟定实施全市继续医学教育、卫生建康专业技术人员培训。管理全市医疗卫生学会社团组织，负责卫生界各学会的计划、组织和学术活动安排。组织开展全市卫生系统学术论文、科研成果及主管部门委托交办的专业技术等评选、评审、鉴定和推荐申报工作。承担全市医疗事故技术鉴定、免疫预防接种异常反应鉴定及职业病诊断鉴定的日常工作。组织开展医师定期考核等工作。承办政府及有关部门委托的工作任务；推动医学科研成果的转化和应用；向政府反映医学科技工作者的意见和要求。</span></p>
          <p align="left" style=" text-align:left"><span style="font-size:16px"><strong style="font-size: 20px;">社团组织</strong></span></p>
          <p style="font-size:16px;text-indent: 2em;"><strong style="font-size: 20px;"><span style="font-size:16px">十堰市卫生界一级学会（协会）</span></strong><span style="font-size:16px"></span></p>
          <p style="font-size:16px;text-indent: 2em;"><span style="font-size:16px">十堰市医学会</span></p>
          <p style="font-size:16px;text-indent: 2em;"><span style="font-size:16px">十堰市医师协会</span></p>
          <p style="font-size:16px;text-indent: 2em;">
            <span style="font-size:16px">十堰市医院协会</span></p>
          <p style="font-size:16px;text-indent: 2em;">
            <span style="font-size:16px">十堰市预防医学会</span></p>
          <p style="font-size:16px;text-indent: 2em;">
            <span style="font-size:16px">十堰市护理学会</span></p>
          <p style="font-size:16px;text-indent: 2em;">
            <span style="font-size:16px">十堰市中医学会</span></p>
          <p style="font-size:16px;text-indent: 2em;">
            <span style="font-size:16px">十堰市中西医结合学会</span></p>
          <p style="font-size:16px;text-indent: 2em;">
            <span style="font-size:16px">十堰市医学伦理学会</span></p>
          <p style="font-size:16px;text-indent: 2em;">
            <span style="font-size:16px">十堰市康复医学会</span></p>
          <p style="font-size:16px;text-indent: 2em;">
            <span style="font-size:16px">十堰市针灸推拿学会</span></p>
          <p style="font-size:16px;text-indent: 2em;">
            <span style="font-size:16px">十堰市抗癌协会</span></p>
          <p style="font-size:16px;text-indent: 2em;">
            <span style="font-size:16px">十堰市医院健康管理学会</span></p>
          <p style="font-size:16px;text-indent: 2em;">
            <span style="font-size:16px">十堰市卫生统计与信息学会</span></p>
          <p style="font-size:16px;text-indent: 2em;"><span style="font-size:16px">&nbsp;十堰市心理卫生协会</span></p>
          <p><span style="font-size:16px">&nbsp;</span></p>
          <p align="center" style=" text-align:center"><span style="font-size:16px"><strong style="font-size: 20px;">十堰市卫生界学会办公室</strong></span></p>
          <p align="left" style=" text-align:left"><span style="font-size:16px">地 址：十堰市柳林路46号</span></p>
          <p align="left" style=" text-align:left"><span style="font-size:16px">邮 编：442000</span></p>
          <p align="left" style=" text-align:left"><span style="font-size:16px">电 话：0719-8652453</span></p>
          <p align="left" style=" text-align:left"><span style="font-size:16px">邮 箱：sy8652453@126.com</span></p>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  export default {
    mounted () {
      document.getElementById("J_GotoTop").style.visibility="hidden";//隐藏在线客服
    },
    destroyed () {
      document.getElementById("J_GotoTop").style.visibility="visible" //显示在线客服
    },
  }
</script>
<style scope>
  table p span{}
</style>



// WEBPACK FOOTER //
// src/views/About.vue